import { DataTablePresenter, ITableColumn } from '@enter/core';
import * as d3 from 'd3';
import { formatDistanceToNow } from 'date-fns';
import React from 'react';
import * as S from '../shared.styles';

interface ISessionInfo {
    browser: string;
    device: string;
    location: string;
    ipAddress: string;
    lastActivity: Date;
    currentSession: boolean;
}

export class LoginHistory extends React.PureComponent {
    private presenter: DataTablePresenter<ISessionInfo>;

    constructor(props: {}) {
        super(props);

        this.presenter = new DataTablePresenter<ISessionInfo>({
            name: 'loginHistory',
            data: this.data,
            columns: this.columns,
            filterSchemas: [],
        });
    }

    private data: ISessionInfo[] = [
        {
            browser: 'Chrome (X)',
            device: 'macOS X 10.14.6',
            location: 'San Francisco, CA USA',
            ipAddress: '24.130.112.103',
            lastActivity: d3.timeHour.floor(new Date()),
            currentSession: true,
        },
        {
            browser: 'Safari (iPhone)',
            device: 'iOS 12.4.1',
            location: 'San Francisco, CA USA',
            ipAddress: '24.130.112.103',
            lastActivity: d3.timeDay.floor(new Date()),
            currentSession: false,
        },
    ];

    private columns: ITableColumn<ISessionInfo>[] = [
        {
            id: 'browserDevice',
            Header: () => <S.TableHeader>Browser/Device</S.TableHeader>,
            Cell: ({ row }): React.ReactElement => (
                <S.TableCell>
                    <S.TableCellTop>{row.original.browser}</S.TableCellTop>
                    <S.TableCellBottom>{row.original.device}</S.TableCellBottom>
                </S.TableCell>
            ),
        },
        {
            id: 'Location',
            Header: () => <S.TableHeader>Location</S.TableHeader>,
            Cell: ({ row }): React.ReactElement => (
                <S.TableCell>
                    <S.TableCellTop>{row.original.location}</S.TableCellTop>
                    <S.TableCellBottom>{row.original.ipAddress}</S.TableCellBottom>
                </S.TableCell>
            ),
        },
        {
            id: 'LastActivity',
            Header: () => <S.TableHeader>Last Activity</S.TableHeader>,
            Cell: ({ row }): React.ReactElement => (
                <S.TableCell>
                    <S.TableCellTop>
                        {formatDistanceToNow(row.original.lastActivity, { addSuffix: true })}
                    </S.TableCellTop>
                    <S.TableCellBottom>{row.original.currentSession && 'current session'}</S.TableCellBottom>
                </S.TableCell>
            ),
        },
        {
            id: 'action',
            Cell: ({ row }): React.ReactElement | undefined =>
                row.original.currentSession ? (
                    <S.TableCellButton variant="outlined" onClick={this.handleLogOut}>
                        Log out
                    </S.TableCellButton>
                ) : undefined,
        },
    ];

    public render(): React.ReactElement {
        return (
            <S.SubCategoryItem>
                <S.SubCategoryH1>Login History</S.SubCategoryH1>
                <S.Table presenter={this.presenter} hideFiltering={true} hidePagination={true} hideSettings={true} />
            </S.SubCategoryItem>
        );
    }

    private readonly handleLogOut = (): void => {
        window.alert('TODO: Logout session');
    };
}
